<div
  id="{{ tooltipOptions.tooltipID }}"
  (click)="$event.stopPropagation()"
  class="tooltip-container border-rounded"
  #tooltipContent
  [ngStyle]="tooltipPosition$ | async"
  [ngClass]="{ absolute: isAbsolutePosition, fixed: !isAbsolutePosition }"
  fcomTrapFocus
>
  <div
    *ngIf="showArrowCaret"
    class="arrow-container"
    [ngClass]="arrowPositionClass"
    [style.left.px]="arrowPosition$ | async"
  >
    <div class="arrow"></div>
  </div>
  <div
    class="tooltip white-bg shadow flex flex--column flex--wrap flex--align-start align-left"
    [class.rounded-large]="roundedCorners"
    [class.ps-medium]="hasPadding"
    [class.tooltip-border]="showLeftBorder"
  >
    <div class="flex flex--align-start fill">
      <div class="flex-1" aria-live="polite">
        <ng-container *ngTemplateOutlet="content"></ng-container>
      </div>
      <button
        class="tooltip-close-x nordic-blue-900-text"
        type="button"
        [attr.aria-label]="ariaCloseText"
        (click)="closeTooltip($event)"
        #closeButton
        *ngIf="tooltipOptions && (tooltipOptions.enableOnClick || tooltipOptions.openByDefault)"
      >
        <fcom-icon class="ir-xxsmall" name="close-delete"></fcom-icon>
      </button>
    </div>

    <button type="button" class="font-body-1 mr-xxsmall-t" (click)="closeTooltip($event)" *ngIf="closeText">
      {{ closeText }}
    </button>
  </div>
</div>
